import * as React from 'react';

export const header = {
  heading: 'Our Sites and Children'
};
export const richText1 = {
  id: 'SitesAndChildren',
  html:
    '                <p>Our websites and device applications are not created for children. To our knowledge \n'
    + '                 we neither collect online information from nor sell information regarding children \n'
    + '                 under 18. If you are a parent or guardian and think we have information about your child, \n'
    + '                 please email <a href ="mailto:customercare@homedepot.com">customercare@homedepot.com</a>. \n'
    + '                 To learn more about how to protect your child online, visit the FTC&apos;s \n'
    + '                 <a href= "https://www.consumer.ftc.gov/features/feature-0038-onguardonline">www.OnGuardOnline.gov</a>.\n'
    + '                 You may also want to read the helpful information about children and privacy that the \n'
    + '                 FTC provides by clicking <a href = "https://www.consumer.ftc.gov/articles/0031-protecting-your-childs-privacy-online">\n'
    + '                 here </a>. </p> \n'
};
